'use strict';

import Vue from 'vue/dist/vue.common.js';

// components
import AddFavorite from '../components/add-favorite';
import DistrictMap from '../components/district-map';

let DistrictBillboard = Vue.extend({
  components: {
    AddFavorite,
    DistrictMap
  },
});

export default DistrictBillboard;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/district-billboard.js